/* eslint-disable sciencepo-rules/require-story */
import React from 'react';
import PropTypes from 'prop-types';
import BibHoraire from '../custom/BibHoraire';
import BibSearchEngine from '../custom/BibSearchEngine';
import BibCalendar from '../custom/BibCalendar';
import BibCalendarNoAnimation from '../custom/BibCalendarNoAnimation';
import ToolSearch from '../custom/ToolSearch';

const widgetComps = {
  'BibHoraire': BibHoraire,
  'BibSearchEngine': BibSearchEngine,
  'BibCalendar': BibCalendar,
  'BibCalendarNoAnimation': BibCalendarNoAnimation,
  'ToolsSearch': ToolSearch,
};

const ReactComponent = (props) => {
  const Comps = widgetComps[props.elem.objectClass];
  if (Comps === undefined) {
    return null;
  }
  return (
    <Comps {...props}/>
  );
};

ReactComponent.propTypes = {
  elem: PropTypes.shape({
    objectClass: PropTypes.string
  })
};

export default ReactComponent;
